import { School } from '../../../typings';
import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export function getSuggestedSchoolsByGeoId(text: string, geoId: string | number): Promise<Array<School>> {
    const { apiGetContactsSuggest } = apiConfig.getStaticUrls();

    return getFetch(apiGetContactsSuggest, { kind: 'school', text, locality: Number(geoId) });
}
